import React from "react";
import './footer.scss';
import axios from 'axios';
export class Footer extends React.Component<any, any> {
    feedbackForm = { name: '', email: '', message: '' };
    footerData = this.props.footerData;
    
    footerItem: any = [
        {
            key: 'Phone',
            value: this.footerData.phone
        },
        {
            key: 'Skype Id',
            value: this.footerData.skypeId
        },
        {
            key: 'Email',
            value: this.footerData.emailId
        }
    ];
    socialList: any = [
        {
            name: 'Facebook',
            url: this.footerData.facebookUrl
        },
        {
            name: 'Linkedin',
            url: this.footerData.linkedInUrl
        },
        {
            name: 'GitHub',
            url: this.footerData.gitHubUrl
        }
    ]
    constructor(props: any) {
        super(props);
        this.state = { ...this.feedbackForm, isSpinerReq: false, isSuccessResponse: false}
        this.send = this.send.bind(this);
        // console.log(this.footerData)
    }
    handleChange(evt, field) {
        this.setState({ [field]: evt.target.value });
    }
    send(event) {
        event.preventDefault();
        // const url = 'https://sheet.best/api/sheets/a3d62836-068b-49fd-a5fb-bfb4ba48e747';
        const url = this.footerData.feedbackUrl
        const data = {
            Date: (new Date().toISOString().slice(0, 10)).split('-').reverse().join('-'),
            Name: this.state.name,
            Email: this.state.email,
            Message: this.state.message

        }
        this.setState({isSpinerReq: true});
        axios.post(url, data).then(()=> {
            this.setState({...this.feedbackForm, isSpinerReq: false, isSuccessResponse: true});
            setTimeout(()=> {
                this.setState({isSuccessResponse: false})
            }, 4000)
        })
        // console.log(data)
    }

    validate(values) {

    }
    render(): React.ReactNode {
        return (
            <div className="footer">
                <div className="container">
                    <div className="footer__heading">Get in touch</div>
                    <div className="footer__wrapper">
                        <div className="footer__info">
                            <div className="footer__contact--list">
                                {
                                    this.footerItem.map((item: any, index: number) => {
                                        return (
                                            <div className="footer__item" key={index}>
                                                <span className="footer__title">{item.key}:</span>
                                                <span>{item.value}</span>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            {
                                this.socialList.map((item: any, index: number) => {
                                    return (
                                        <div className="footer__contact--list" key={index}>
                                            <a href={item.url} target="_blank" className="footer__link" rel="noreferrer" key={index}>{item.name}</a>
                                        </div>
                                    )
                                })
                            }

                        </div>
                        <div className="footer__latter">
                            <div className="footer__item">Just write me a letter here..</div>
                            <form className="footer__form" onSubmit={this.send}>
                                <input type="text" id="name" name="name" placeholder="Your name." value={this.state.name} onChange={(event) => this.handleChange(event, "name")} />
                                <input type="text" placeholder="Your Email." id="email" name="email" value={this.state.email} onChange={(event) => this.handleChange(event, "email")} />
                                <textarea className="txtarea-message" placeholder="Type the message here." value={this.state.message} id="message" onChange={(event) => this.handleChange(event, "message")}> </textarea>
                               { this.state.isSuccessResponse && <div className="footer__success" id="sucess-txt">Thanks for your valuable letter.. </div>}
                                <button type="submit" className="app-btn" disabled={!this.state.name || !this.state.email || !this.state.message}>
                                {this.state.isSpinerReq ? <div className="loader"></div> : <span>Send</span>}
                                </button>
                            </form>
                        </div>

                    </div>
                    <p className="footer__copyright" property="dc:rights">&copy;
                        <span property="dc:dateCopyrighted">2021</span>
                        <span property="dc:publisher">development</span>
                    </p>
                </div>
            </div>
        )
    }
}

export default Footer;